import PublicoEnum from "../domain/web/PublicoEnum";

export default ({ next, router, to, store }) => {
  const { idPublico } = store.state.ambientes.atual;
  const publicoPermitido = [
    PublicoEnum.ALUNO,
    PublicoEnum.PROFESSOR,
    PublicoEnum.FUNCIONARIO,
    PublicoEnum.PROFESSOR_COLEGIO,
    PublicoEnum.ALUNO_EAD
  ];

  if (!publicoPermitido.includes(idPublico)) {
    return router.push(`/`);
  }

  return next();
};



// WEBPACK FOOTER //
// ./src/middleware/isIndicai.js